// 👤 Mi cuenta — pantalla propia del usuario logueado (cualquier usuario, sin
// depender de nivel de acceso): cambiar contraseña y, donde la BD lo tiene,
// verificación en dos pasos (MFA). Crece con más secciones (preferencias, sesiones…).
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { KeyRound, Loader2, User } from 'lucide-react';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import { authAPI } from '@/lib/api/auth.api';
import { getErrorMessage } from '@/lib/api/client';
import { useTranslation } from '@/lib/hooks/useTranslation';
import { MfaCard } from './MfaCard';

const inputCls = 'w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring';

function CambiarClaveCard() {
  const { t } = useTranslation();
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [confirmar, setConfirmar] = useState('');

  const cambiar = useMutation({
    mutationFn: () => authAPI.cambiarClave(actual, nueva),
    onSuccess: () => {
      toast.success(t('cuenta.claveActualizada'));
      setActual('');
      setNueva('');
      setConfirmar('');
    },
    onError: (e) => toast.error(getErrorMessage(e)),
  });

  const errNueva = nueva.length > 0 && nueva.length < 8 ? t('cuenta.minimo8') : '';
  const errConf = confirmar.length > 0 && confirmar !== nueva ? t('cuenta.noCoincide') : '';
  const puede = actual.length > 0 && nueva.length >= 8 && confirmar === nueva;

  return (
    <Card>
      <CardHeader className="flex-row items-center gap-2 space-y-0">
        <KeyRound className="h-5 w-5 text-muted-foreground" />
        <CardTitle className="text-base">{t('cuenta.cambiarClave')}</CardTitle>
      </CardHeader>
      <CardContent className="max-w-md space-y-3">
        <div>
          <label className="text-xs text-muted-foreground">{t('cuenta.claveActual')}</label>
          <input type="password" className={inputCls} value={actual} onChange={(e) => setActual(e.target.value)} autoComplete="current-password" />
        </div>
        <div>
          <label className="text-xs text-muted-foreground">{t('cuenta.claveNueva')}</label>
          <input type="password" className={inputCls} value={nueva} onChange={(e) => setNueva(e.target.value)} autoComplete="new-password" />
          {errNueva && <p className="text-xs text-urgente mt-1">{errNueva}</p>}
        </div>
        <div>
          <label className="text-xs text-muted-foreground">{t('cuenta.confirmarClave')}</label>
          <input type="password" className={inputCls} value={confirmar} onChange={(e) => setConfirmar(e.target.value)} autoComplete="new-password" />
          {errConf && <p className="text-xs text-urgente mt-1">{errConf}</p>}
        </div>
        <Button disabled={!puede || cambiar.isPending} onClick={() => cambiar.mutate()}>
          {cambiar.isPending && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
          {t('cuenta.guardar')}
        </Button>
      </CardContent>
    </Card>
  );
}

export function MiCuenta() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6 p-6">
      <div className="flex items-center gap-2">
        <User className="h-6 w-6 text-muted-foreground" />
        <h1 className="text-2xl font-semibold">{t('cuenta.titulo')}</h1>
      </div>

      <CambiarClaveCard />
      <MfaCard />
    </div>
  );
}
